import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ConfirmEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const confirmEmail = async () => {
      const token = new URLSearchParams(location.search).get('token');
      if (!token) {
        navigate('/login'); // Redirect to login if no token
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/confirm-email?token=${token}`);
        if (!response.ok) {
          throw new Error('Email confirmation failed');
        }
        
        navigate('/login'); // Redirect to login page after confirmation
      } catch (error) {
        console.error('Error confirming email:', error);
        setError('Email confirmation failed. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    confirmEmail();
  }, [location.search, navigate]);

  if (loading) {
    return <div>Redirecting...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return null; // or any other feedback you want to give
};

export default ConfirmEmail;
